query ListEventsPage($limit: Int, $nextToken: String, $status: String, $search: String) {
  page: StreamToolsListEventsPage(limit: $limit, nextToken: $nextToken, status: $status, search: $search) {
    items {
      eventId
      slug
      name
      status
      createdAt
    }
    nextToken
  }
}
